export enum PracticeTaxIdType {
    EIN = "EI",
    SSN = "SY",
}

export enum UpdateUsersInGroupOperation {
    ADD = "ADD",
    REMOVE = "REMOVE",
}

export const COMMON_PRACTICE_CONFIG = {
    defaultTaxIdType: PracticeTaxIdType.EIN,
}
